import apiClient from './ApiInterceptor';

export const sendMessage = (payload) => {
  // POST to backend route that will handle LLM/internal chat queries.
  return apiClient.post('/internal-chat', payload);
};

export const createSession = (payload) => {
  return apiClient.post('/internal-chat/sessions', payload);
};

export const listSessions = (params) => {
  return apiClient.get('/internal-chat/sessions', { params });
};

export const getMessages = (sessionId, params) => {
  return apiClient.get(`/internal-chat/sessions/${sessionId}/messages`, { params });
};

export const updateSession = (sessionId, payload) => {
  return apiClient.patch(`/internal-chat/sessions/${sessionId}`, payload);
};

export const deleteSession = (sessionId) => {
  // Soft-delete a session on the server; server should set deleted_at
  return apiClient.delete(`/internal-chat/sessions/${sessionId}`);
};

export const reprocessMessage = (messageId) => {
  return apiClient.post(`/internal-chat/reprocess/${messageId}`);
};


